import { useMemo } from 'react';
import { ResourceAllocationFiltersContext } from '../state/filters/contexts';
import useIsTreeHierarchyEnabled from '../state/filters/hooks/useIsTreeHierarchyEnabled';
import { keyBy, omitBy, orderBy, values } from 'lodash';
import { resourceAllocationTypesEnum } from '@linearb/linjs-common';
import useIssueTypes from 'common/fetchHooks/pmProvider/useIssueTypes';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { generateResourceTypeFromIssueType } from './resource_types';

const useResourceTypesTreeHierarchy = defaultResourceTypes => {
  const pmProvider = usePmProvider();
  const isTreeHierarchyEnabled = useIsTreeHierarchyEnabled(
    ResourceAllocationFiltersContext
  );
  const { issueTypes, isLoading } = useIssueTypes({
    enabled: isTreeHierarchyEnabled
  });

  const resourceTypesTreeHierarchy = useMemo(() => {
    if (!isTreeHierarchyEnabled) return defaultResourceTypes;

    let resourceTypes = { ...defaultResourceTypes };
    const typesToDelete = [
      resourceAllocationTypesEnum.INITIATIVE,
      resourceAllocationTypesEnum.EPIC,
      resourceAllocationTypesEnum.FEATURE
    ];
    resourceTypes = omitBy(resourceTypes, resourceType =>
      typesToDelete.includes(resourceType.type)
    );

    const resourceTypesArr = values(resourceTypes);
    const issueTypesResourceTypesArr = issueTypes.map(issueType =>
      generateResourceTypeFromIssueType(issueType.issue_type, pmProvider)
    );
    const allResourceTypesArray = [
      ...resourceTypesArr,
      ...issueTypesResourceTypesArr
    ];

    const orderTypesPriority = [
      resourceAllocationTypesEnum.PROJECT,
      resourceAllocationTypesEnum.LABEL,
      resourceAllocationTypesEnum.DYNAMIC_ISSUE_TYPE,
      resourceAllocationTypesEnum.CUSTOM_FIELD
    ];
    const orderedResourceTypesArray = orderBy(
      allResourceTypesArray,
      resourceType => orderTypesPriority.indexOf(resourceType.type)
    );
    const orederedResourceTypes = keyBy(orderedResourceTypesArray, 'key');

    return orederedResourceTypes;
  }, [defaultResourceTypes, isTreeHierarchyEnabled, issueTypes]);

  return [resourceTypesTreeHierarchy, isLoading];
};

export default useResourceTypesTreeHierarchy;
